module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amber Lanier Nagle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amber Lanier Nagle is a freelance writer based in Georgia. She’s published articles in "), _c('I', [_vm._v("Grit")]), _vm._v(", "), _c('I', [_vm._v("Mother Earth News")]), _vm._v(", "), _c('I', [_vm._v("Points North")]), _vm._v(", and many other magazines. When she isn’t writing, Nagle spends time outdoors with her husband and works with aspiring writers.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gmI5Uq/tc-custom/9781504079426.jpg?1705239545846",
      "alt": "This image is the cover for the book Project Keepsake"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Project Keepsake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Fascinating personal histories are revealed through the stories of cherished objects, in this anthology celebrating the meaningful mementos of our lives. ")]), _c('br'), _c('br'), _vm._v(" Amber Lanier Nagle has always been interested in keepsakes, whether her own or those she encounters in her friends’ homes. Seemingly ordinary items—a glass bluebird, a pocketknife, a dime-store locket, a faded fishing lure, a dented cake pan, a model train car—become priceless treasures when their stories are uncovered. In "), _c('i', [_vm._v("Project Keepsake")]), _vm._v(", Nagle collects the tales of these objects and their beloved memories from contributors near and far."), _c('br'), _c('br'), _vm._v(" “Why do you keep this?” Nagle asks. “Where did it come from?” And then she listens as the stories pour out. Told in first-person by both seasoned and aspiring writers, every essay in the anthology is unique—yet each reveals common threads that connect us all and celebrate the glorious human experience.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0